export const constant =
  <T>(value: T): (() => T) =>
  () =>
    value
export const constNull = constant(null)
export const constUndefined = constant(undefined)
export const constEmptyArray = constant([])
export const constVoid = constant(undefined as void)
export const constEmptyResult = constant({ _tag: 'Right' as const })
